const compactFormat = new Intl.NumberFormat('en-US', { notation: "compact", compactDisplay: "short" })
const twoDecimalFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 })
const longFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 20, maximumSignificantDigits: 15 })

const formatNumber = (value, type) => {
    if (type === 'compact') {
        return compactFormat.format(value)
    } else if (type === '2Decimals') {
        return twoDecimalFormat.format(value)
    } else {
        return longFormat.format(value)
    }
}

export { formatNumber }